import React, { useContext } from "react";
import { ThemeContext } from "styled-components";

import { IconContainer, IconElement } from "./styled";
import { TColor } from "../../theme";

export type IconNames =
  | "attachFile"
  | "accessTime"
  | "accountBox"
  | "add"
  | "addCircle"
  | "addOutline"
  | "angelList"
  | "analytics"
  | "arrowBack"
  | "arrowRight"
  | "arrowAltUp"
  | "arrowAltDown"
  | "assessment"
  | "bug"
  | "bulb"
  | "calendar"
  | "caretDown"
  | "caretUp"
  | "caretRight"
  | "check"
  | "chromeReaderMode"
  | "close"
  | "code"
  | "codepen"
  | "compare"
  | "controlPointDuplicate"
  | "cv"
  | "dehaze"
  | "delete"
  | "deleteOutline"
  | "discordAlt"
  | "dotsHorizontal"
  | "dotsVertical"
  | "edit"
  | "exitAlt"
  | "externalLink"
  | "eye"
  | "feedback"
  | "fullscreen"
  | "fullscreenExit"
  | "git"
  | "gist"
  | "gitBranch"
  | "gitBranchLight"
  | "gitCommit"
  | "gitMerge"
  | "gitRepo"
  | "gitRepoAdd"
  | "github"
  | "githubIssue"
  | "githubLight"
  | "graphicEq"
  | "handyman"
  | "help"
  | "instagram"
  | "issue"
  | "linkedin"
  | "logOut"
  | "person"
  | "personOutline"
  | "personSearch"
  | "readme"
  | "repo"
  | "search"
  | "settings"
  | "stackOverflow"
  | "stackExchange"
  | "star"
  | "stars"
  | "starOutline"
  | "tiktok"
  | "topic"
  | "trend"
  | "twitter"
  | "emailLight"
  | "comment"
  | "commentOutline"
  | "pin"
  | "pinDrop"
  | "screenShare"
  | "thumbsUp"
  | "thumbsUpFilled"
  | "wallet"
  | "widgets"
  | "work"
  | "workOutline"
  | "world"
  | "worldPin"
  | "extension"
  | "timer"
  | "pullRequest"
  | "repoAlt"
  | "createFolder"
  | "copy"
  | "share"
  | "track"
  | "info"
  | "infoFilled"
  | "fire"
  | "save"
  | "searchUser"
  | "supervisedUser"
  | "briefcase"
  | "laptop"
  | "adjust"
  | "union"
  | "intersection"
  | "blockchain"
  | "helpOutline"
  | "timeline"
  | "questionAnswer"
  | "questionCircle"
  | "quine"
  | "zoomIn"
  | "zoomOut"
  | "zoomReset"
  | "radioUnchecked"
  | "dripper"
  | "refresh"
  | "archive"
  | "company"
  | "removeCircle"
  | "link"
  | "caretLeft"
  | "devto"
  | "kaggleFavicon"
  | "checkmarkPlus"
  | "favourite"
  | "favouriteBorder"
  | "bookmark"
  | "bookmarkBorder"
  | "dnd"
  | "addTo"
  | "view"
  | "unlink"
  | "northEast"
  | "discord"
  | "mastodon"
  | "medium"
  | "quests"
  | "devRank"
  | "textSnippet"
  | "timerAlt"
  | "dollar"
  | "dollarCircled"
  | "trophy"
  | "raisedHand"
  | "loot"
  | "bold"
  | "italic"
  | "bulletedList"
  | "numberedList"
  | "addWidget"
  | "entryLevel"
  | "midLevel"
  | "expertLevel"
  | "enter"
  | "youtube"
  | "crystalBall"
  | "badge"
  | "undo"
  | "media"
  | "rocket"
  | "firstSubmission"
  | "veteran"
  | "medal"
  | "tShirt"
  | "tshirtOutline"
  | "drBadge"
  | "checkCircled"
  | "emptyQuest"
  | "cancel"
  | "devices";

export const ICON_FILE_NAME_MAP: { [key in IconNames]: string } = {
  accessTime: "access-time",
  accountBox: "account-box",
  add: "add",
  addCircle: "add-circle",
  addOutline: "add-outline",
  addTo: "add-to",
  adjust: "adjust",
  analytics: "analytics",
  angelList: "angel-list",
  archive: "archive",
  arrowAltDown: "arrow-alt-down",
  arrowAltUp: "arrow-alt-up",
  arrowBack: "arrow-back",
  arrowRight: "arrow-right",
  assessment: "assessment",
  attachFile: "attach-file",
  blockchain: "blockchain",
  bookmark: "bookmark",
  bookmarkBorder: "bookmark-border",
  briefcase: "briefcase",
  bug: "bug",
  bulb: "bulb",
  calendar: "calendar",
  caretDown: "caret-down",
  caretLeft: "caret-left",
  caretRight: "caret-right",
  caretUp: "caret-up",
  check: "check",
  checkCircled: "check-circled",
  checkmarkPlus: "checkmark-plus",
  chromeReaderMode: "chrome-reader-mode",
  close: "close",
  code: "code",
  codepen: "codepen",
  comment: "comment",
  commentOutline: "comment-outline",
  company: "company",
  compare: "compare",
  controlPointDuplicate: "control-point-duplicate",
  copy: "copy",
  createFolder: "create-folder",
  cv: "cv",
  dehaze: "dehaze",
  delete: "delete",
  deleteOutline: "delete-outline",
  devto: "devto",
  discordAlt: "discord-alt",
  dnd: "dnd",
  dotsHorizontal: "dots-horizontal",
  dotsVertical: "dots-vertical",
  dripper: "dripper",
  edit: "edit",
  emailLight: "email-light",
  exitAlt: "exit-alternative",
  extension: "extension",
  externalLink: "external-link",
  eye: "eye",
  favourite: "favourite",
  favouriteBorder: "favourite-border",
  feedback: "feedback",
  fire: "fire",
  fullscreen: "fullscreen",
  fullscreenExit: "fullscreen-exit",
  gist: "gist",
  git: "git",
  gitBranch: "git-branch",
  gitBranchLight: "git-branch-light",
  gitCommit: "git-commit",
  gitMerge: "git-merge",
  gitRepo: "git-repo",
  gitRepoAdd: "git-repo-add",
  github: "github",
  githubIssue: "github-issue",
  githubLight: "github-light",
  graphicEq: "graphic-eq",
  handyman: "handyman",
  help: "help",
  helpOutline: "help-outline",
  info: "info",
  infoFilled: "info-filled",
  instagram: "instagram",
  intersection: "intersection",
  issue: "issue",
  kaggleFavicon: "kaggle-favicon",
  laptop: "laptop",
  link: "link",
  linkedin: "linkedin",
  logOut: "log-out",
  person: "person",
  personOutline: "person-outline",
  personSearch: "person-search",
  pin: "pin",
  pinDrop: "pin-drop",
  pullRequest: "pull-request",
  questionAnswer: "question-answer",
  questionCircle: "question-circle",
  quine: "quine",
  radioUnchecked: "radio-unchecked",
  readme: "readme",
  refresh: "refresh",
  removeCircle: "remove-circle",
  repo: "repo",
  repoAlt: "repo-alternate",
  save: "save",
  screenShare: "screen-share",
  search: "search",
  searchUser: "search-user",
  settings: "settings",
  share: "share",
  stackExchange: "stack-exchange",
  stackOverflow: "stack-overflow",
  star: "star",
  starOutline: "star-outline",
  stars: "stars",
  supervisedUser: "supervised-user",
  thumbsUp: "thumbs-up",
  thumbsUpFilled: "thumbs-up-filled",
  tiktok: "tiktok",
  timeline: "timeline",
  timer: "timer",
  topic: "topic",
  track: "track",
  trend: "trend",
  twitter: "x",
  union: "union",
  unlink: "unlink",
  view: "view",
  wallet: "wallet",
  widgets: "widgets",
  work: "work",
  workOutline: "work-outline",
  world: "world",
  worldPin: "worldPin",
  zoomIn: "zoom-in",
  zoomOut: "zoom-out",
  zoomReset: "zoom-reset",
  northEast: "north-east",
  discord: "discord",
  mastodon: "mastodon",
  medium: "medium",
  quests: "quests",
  devRank: "dev-rank",
  textSnippet: "text-snippet",
  timerAlt: "timer-alt",
  dollar: "dollar",
  dollarCircled: "dollar-circled",
  trophy: "trophy",
  raisedHand: "raised-hand",
  loot: "loot",
  bold: "bold",
  italic: "italic",
  bulletedList: "bulleted-list",
  numberedList: "numbered-list",
  addWidget: "add-widget",
  entryLevel: "entry-level",
  midLevel: "mid-level",
  expertLevel: "expert-level",
  enter: "enter",
  youtube: "youtube",
  crystalBall: "crystal-ball",
  badge: "badge",
  undo: "undo",
  media: "media",
  rocket: "rocket",
  firstSubmission: "first-submission",
  veteran: "veteran",
  medal: "medal",
  tShirt: "t-shirt",
  tshirtOutline: "tshirt-outline",
  drBadge: "dr-badge",
  emptyQuest: "empty-quest",
  cancel: "cancel",
  devices: "devices",
};

export interface IconProps {
  name: IconNames;
  color?: TColor | "currentColor" | null;
  isInline?: boolean;
  onClick?: (...args: any[]) => void;
  size?: string;
  margin?: React.CSSProperties["margin"];
  verticalAlign?: React.CSSProperties["verticalAlign"];
  className?: string;
}

const Icon: React.FunctionComponent<IconProps> = ({
  name,
  color = "primary",
  isInline,
  onClick,
  size = "24px",
  margin,
  verticalAlign = "baseline",
  className,
}) => {
  const themeContext = useContext(ThemeContext);
  const isInteractive = onClick !== undefined;

  let fillColor: string | undefined = undefined;

  if (color === "currentColor") {
    fillColor = color;
  } else if (color !== null && themeContext) {
    // @ts-ignore
    fillColor = themeContext.colors[color];
  }

  return (
    <IconContainer
      className={className}
      $height={size}
      $margin={margin}
      $verticalAlign={verticalAlign}
      $isInteractive={isInteractive}
      $isInline={isInline}
      onClick={onClick}
    >
      <IconElement
        $name={ICON_FILE_NAME_MAP[name]}
        $color={fillColor}
        $size={size}
      />
    </IconContainer>
  );
};

export default Icon;
